module.exports = __webpack_public_path__ + "static/img/head_5.1847bbdb.png";